/**
 * Just view/template component, no model/data logic!
 */
import React from "react"
import Img from 'gatsby-image'
import Image from "../../../image"
// import SEO from "./../../seo"

// s4n
import { injectIntl } from "gatsby-plugin-intl"
import { Carousel } from 'react-bootstrap'



/**
 * Component displays all main (first of each variant) images for all variants (if any) or placeholder empty image.
 * If article has more than one variant, each main variant image will be displayed as carousel images.
 * 
 * @param { intl, product, carousel } props 
 */
const ComponentStateless = (props) => {

    const { intl, product, carousel } = props
    const t = intl.formatMessage
  
    const isCarousel = carousel || false;
    const variations = product && product.relationships && product.relationships.variations ? product.relationships.variations : [];

    let images = [];
    variations.map((variation, index) => {

        // console.log(variation.relationships.field_images)

        const imageDerivative = variation && variation.relationships && variation.relationships.field_images.length ? variation.relationships.field_images[0].derivative : null;
        const imageLocalFile = variation && variation.relationships && variation.relationships.field_images.length ? variation.relationships.field_images[0].localFile : null;
        if (imageDerivative || imageLocalFile) {
            images.push({
                derivative: imageDerivative,
                fluid: imageLocalFile.childImageSharp.fluid,
                alt: variation.title,
            });
        }
    });
    
    if (0 === images.length) {
        return <Image />;
    }
    
    const hasControls = images.length > 1;

    return (
        <React.Fragment>
            {
                !isCarousel ? 
                    <React.Fragment>
                        {images[0].derivative && <img src={images[0].derivative.url} width={images[0].derivative.width} height={images[0].derivative.height} alt={images[0].alt} />}
                        {images[0].fluid && <Img fluid={images[0].fluid} alt={images[0].alt} />}
                    </React.Fragment>
                    :
                    // @see: https://react-bootstrap.github.io/components/carousel/
                    <Carousel
                        interval={null}
                        // indicators={false}
                        controls={hasControls}
                    >
                        {images.map((image, index) => {
                            return (
                                <Carousel.Item>
                                    {/* <img
                                        className="d-block w-100"
                                        src="holder.js/800x400?text=First slide&bg=373940"
                                        alt="First slide"
                                    /> */}
                                    <Img fluid={ image.fluid } alt={image.alt} />
                                    {/* <Carousel.Caption>
                                        <h3>First slide label</h3>
                                        <p>Nulla vitae elit libero, a pharetra augue mollis interdum.</p>
                                    </Carousel.Caption> */}
                                </Carousel.Item>
                            );
                        })}
                    </Carousel>
            }
        </React.Fragment>
    )
}

export default injectIntl(ComponentStateless)
